import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { ApiService } from 'src/app/services/api.service';
@Component({
  selector: 'app-register-business-model-dashborad',
  templateUrl: './register-business-model-dashborad.component.html',
  styleUrls: ['./register-business-model-dashborad.component.css']
})
export class RegisterBusinessModelDashboradComponent implements OnInit {
  parentCompnyGroup: FormGroup;
  nickNameGroup: FormGroup;
  ModelTab = 0;
  parentCompanyID = '';
  parentCompanyList: any;
  filteredOptions: Observable<string[]>;

  constructor(
    private formBuilder: FormBuilder
    , private api: ApiService
  ) {
    this.parentCompnyGroup = this.formBuilder.group({
      prntCmpny: new FormControl('', Validators.required)
    });
    this.nickNameGroup = this.formBuilder.group({
      nickName: new FormControl('', Validators.required)
    });
  }
  private _filter(value: string): string[] {
    if (typeof value !== 'string') {
      return null;
    } else {
      const filterValue = value.toLowerCase();
      return this.parentCompanyList.filter(option => option['nickname'].toLowerCase().includes(filterValue));
    }
  }
  bindParentCompany() {
    this.api.functionGET('business/business_nicknames').subscribe((res) => {
      this.parentCompanyList = res['data'];
      this.filteredOptions = this.parentCompnyGroup.get('prntCmpny').valueChanges
        .pipe(
           startWith(''),
          map(value => this._filter(value))
        );
    },
      err => {

      });
  }
  getNickname($event) {
    this.parentCompnyGroup.patchValue({
      prntCmpny: $event.option.value['nickname']
    });
    this.parentCompanyID = $event.option.value['bp_business_id'];
  }
  ngOnInit() {
    this.bindParentCompany();
  }
}
